module.exports = __webpack_public_path__ + "32509e14f6efb669afcd607ec1a2b66b.svg";